import React from 'react'

const CamIndicator = ({ available, enabled }) => {

  const colorClass = available ? 'text-white' : 'text-danger';
  const iconClass = (available && enabled) ? 'fa-video' : 'fa-video-slash';

  const classNames = [
    'fas',
    'fa-fw',
    iconClass,
    colorClass,
  ].join(' ');

  return (
    <span className="mr-1">
      <i className={classNames}></i>
    </span>
  );
}

export default CamIndicator;